export enum TelephoneSocial {
  VIBER = 'viber',
  WHATSAPP = 'whatsapp'
}
